<template>
  <div class="interactives-check-input">
      <legend>{{ inputData.label }}</legend>
      <div class="options" v-for="option in inputData.options">
          <input
              type="checkbox"
              :name="option.name"
              :value="option.value !== undefined ? option.value : option.label"
              v-model="value"
          >
          <label :for="option.name">{{ option.label }}</label>
      </div>
  </div>
</template>

<script>

export default {
  name: 'interactives-check-input',
  props: ['inputData'],
  data () {
    return {
      value: []
    }
  },
  watch: {
    value: function (newValue) { this.inputData.value = newValue }
  }
}
</script>

<style>
.interactives-check-input {
  /* styles go here */
}
</style>



// WEBPACK FOOTER //
// ../interactives-input/src/components/CheckInput.vue